import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {AuthService} from "./services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  console.log('authInterceptor', authService.token);

  if (authService.token === undefined) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: { Authorization: `Bearer ${authService.token}` },
  }));
};
